import { render, staticRenderFns } from "./CbsReportConfigStep.vue?vue&type=template&id=51885ac3&scoped=true"
import script from "./CbsReportConfigStep.vue?vue&type=script&lang=js"
export * from "./CbsReportConfigStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51885ac3",
  null
  
)

export default component.exports